<template>
  <Badge class="filter-badge lisaui:cursor-pointer">
    <i v-if="filter.isNegated" class="filter-badge-prefix fas fa-not-equal" />
    <i v-if="icon" class="filter-badge-icon" :class="icon" aria-hidden="true" />
    <span class="filter-badge-content">
      <slot />
    </span>
    <LISAButton
      class="filter-badge-remove"
      size="sm"
      variant="neutral"
      text
      icon="fas fa-times"
      :aria-label="t('global.delete')"
      @click.stop="$emit('remove')"
    />
  </Badge>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import Badge from "@/components/badges/BadgeComponent.vue";
import { LISAButton } from "@fi-solutions/lisa-ui";
import { useTranslation } from "@/language/translation";

type FilterBadgeFilter = {
  isNegated?: boolean;
};

defineProps({
  filter: {
    type: Object as PropType<FilterBadgeFilter>,
    required: true,
  },
  icon: {
    type: String,
    default: undefined,
  },
});
defineEmits(["remove"]);
const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.filter-badge {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.filter-badge-prefix,
.filter-badge-icon,
.filter-badge-remove {
  flex: 0 0 auto;
}

.filter-badge-icon {
  display: inline-flex;
  width: 1.25em;
  height: 1.25em;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  line-height: 1;
  text-align: center;
}

.filter-badge-content {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-badge-remove {
  min-width: 1.5rem;
  min-height: 1.5rem;
  padding: 0;
  color: inherit;
  opacity: 0.65;
}

.filter-badge-remove:hover {
  opacity: 1;
}
</style>
